import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/orders`, {params})
    },
    update(id, params) {
        return Vue.axios.post(`/orders/update/${id}`, params)
    },
    updatePayStatus(id) {
        return Vue.axios.get(`/orders/update/${id}/pay-status`)
    },
    getIikoReport(id) {
        return Vue.axios.get(`/orders/${id}/iiko-report`)
    },
    setOpen(id) {
        return Vue.axios.get(`/orders/set-open/${id}`)
    },
    toggleIsProcessed(id) {
        return Vue.axios.get(`/orders/toggle-is-processed/${id}`)
    },
    toggleIsPaid(id) {
        return Vue.axios.get(`/orders/toggle-is-paid/${id}`)
    },
    sendToIiko(id, terminalId) {
        let terminalUrl = terminalId ? '/' + terminalId : ''
        return Vue.axios.get(`/orders/send-to-iiko/${id}` + terminalUrl)
    },
    getSources() {
        return Vue.axios.get(`/orders/sources`)
    },
    getDeliveryTime() {
        return Vue.axios.get(`/orders/get-delivery-time?is_self_delivery=1`)
    },
    getDeliveryTimeList(params) {
        return Vue.axios.get(`/orders/list-delivery-time`, {params})
    },
    toggleDeliveryTime(data) {
        return Vue.axios.post(`/orders/toggle-delivery-time`, data)
    },
    createCheckboxReceipt(id) {
        return Vue.axios.get(`/admin/orders/${id}/create-checkbox-receipt`)
    }
    // create() {
    //     return Vue.aiox.post('/api/posts')
    // }
    // // etc
}
